var scrolledToolbar = 'fx_2d2fb1e5_bf6bgv2';
var toolbar = 'fx_2d2fb1e5_bf6bgv1';
var toolbarWidth = 'var(--fx_2d2fb1e5_bf6bgv0)';

export { scrolledToolbar, toolbar, toolbarWidth };
//# sourceMappingURL=toolbar.vanilla.mjs.map
